export const motionVariants = {
  enter: {
    opacity: 1,
    transition: { staggerChildren: 0.5 },
  },
  opacity: 0,
  exit: { transition: { staggerChildren: 0.5 } },
};

export const transition = { duration: 0.5, ease: "easeInOut" };
export const stepContent = {
  initial: { opacity: 0 },
  enter: {
    opacity: 1,
    transition: { staggerChildren: 0.5, delayChildren: 0.5 },
  },
  exit: { transition: { staggerChildren: 0.5 } },
};

export const cartParent = {
  initial: { opacity: 0 },
  enter: {
    opacity: 1,
    transition: { staggerChildren: 0.5, delayChildren: 0.5 },
  },
};

export const pageTransition = {
  initial: { x: -50, opacity: 0 },
  enter: {
    x: 0,
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3,
      duration: 0.5,
      ease: "easeInOut",
    },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.5 },
  },
};

export const loadingMotion = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.3, duration: 0.2 },
  },
};

export const FilterResultsMenuTransition = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
};

export const motionItems = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { duration: 0.2 },
  },
};

export const productsListMotion = {
  enter: { transition: { staggerChildren: 0.2, delayChildren: 0.3 } },
  exit: { transition: { staggerChildren: 0.2, delayChildren: 0.3 } },
};
export const tagVariants = {
  show: {
    opacity: 1,
    transition: {
      delay: 0.3,
      duration: 0.3,
      ease: [0.83, 0, 0.17, 1],
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      duration: 1.2,
      ease: [0.83, 0, 0.17, 1],
    },
  },
};

export const contentContainer = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.2 },
  },
};

export const contentItem = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.3 } },
  exit: { opacity: 0 },
};

export const productsMotion = {
  initial: { y: 50, opacity: 0 },
  enter: { y: 0, opacity: 1, transition },
  exit: { opacity: 0, transition },
  transition: { duration: 0.3, ease: "easeInOut" },
};

export const parentMotion = {
  enter: { transition: { staggerChildren: 0.1, duration: 0.3 } },
  exit: { transition: { staggerChildren: 0.1 } },
};
export const categoriesTransition = {
  initial: { opacity: 0 },
  enter: { x: 0, opacity: 1 },
  exit: { opacity: 0, transition },
  transition: { delay: 1, duration: 0.5, ease: "easeInOut" },
};

export const additionalService = {
  initial: { opacity: 0 },
  enter: { x: 0, opacity: 1, transition },
  exit: { opacity: 0, transition },
};

export const additionalServicesList = {
  initial: { opacity: 0 },
  enter: { x: 0, opacity: 1, transition },
  exit: { opacity: 0, transition },
};

export const cartIcon = {
  initial: { opacity: 0 },
  enter: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 2, duration: 0.2 },
  },
  exit: { opacity: 0 },
};

export const cartContent = {
  initial: { opacity: 0 },
  enter: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 2, duration: 0.3 },
  },
  exit: {
    opacity: 0,
    transition: { staggerChildren: 0.1, delayChildren: 2, duration: 0.3 },
  },
};
